import { render, staticRenderFns } from "./LogoDark.vue?vue&type=template&id=28d643cb"
import script from "./LogoDark.vue?vue&type=script&lang=js"
export * from "./LogoDark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports